import { isStudioModuleEntitled } from "./studioModules";

/** Zoho Books billing sync (module BILLING_SYNC). Off unless the build turns it on; always on locally. */
export const isBillingSyncEnabled = (): boolean =>
  process.env.REACT_APP_BILLING_SYNC_ENABLED === "true" || process.env.REACT_APP_ENV === "loc";

/** Studio staff of a studio that has the module. Super admins look but never push bills. */
export const canUseBillingSync = (role?: string): boolean => {
  if (!isBillingSyncEnabled()) return false;
  if (role !== "ORGANIZATION_ADMIN" && role !== "ORGANIZATION_MANAGER") return false;
  return isStudioModuleEntitled("BILLING_SYNC");
};

/** Connecting or disconnecting Zoho is the studio admin's job; the server refuses anyone else. */
export const canManageBillingSync = (role?: string): boolean =>
  role === "ORGANIZATION_ADMIN" && canUseBillingSync(role);
